module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0132.jpg?v=fe1d1b6b";